import { __read, __spread } from "tslib";
import React, { useMemo } from 'react';
import { getFromPath } from '@keen.io/charts-utils';
import Correlation from './correlation.component';
export var TooltipContent = function (_a) {
    var data = _a.data, typography = _a.typography, labelSelector = _a.labelSelector, selectors = _a.selectors, valueKey = _a.valueKey, xDomainKey = _a.xDomainKey, yDomainKey = _a.yDomainKey, formatValue = _a.formatValue;
    var _b = __read(selectors, 1), firstSelector = _b[0];
    var _c = __read(firstSelector.selector, 1), index = _c[0];
    var series = useMemo(function () {
        return selectors.map(function (_a) {
            var color = _a.color, selector = _a.selector;
            var selectorData = getFromPath(data, selector);
            return {
                title: selectorData[labelSelector],
                color: color,
                correlations: Object.keys(selectorData).reduce(function (acc, keyName) {
                    var value = selectorData[keyName];
                    if ((formatValue === null || formatValue === void 0 ? void 0 : formatValue.xKey) && keyName === xDomainKey)
                        value = formatValue.xKey(selectorData[keyName]);
                    if ((formatValue === null || formatValue === void 0 ? void 0 : formatValue.yKey) && keyName === yDomainKey)
                        value = formatValue.yKey(selectorData[keyName]);
                    if ((formatValue === null || formatValue === void 0 ? void 0 : formatValue.valueKey) && keyName === valueKey)
                        value = formatValue.valueKey(selectorData[keyName]);
                    if (keyName !== labelSelector) {
                        return __spread(acc, [
                            {
                                name: keyName,
                                value: value,
                            },
                        ]);
                    }
                    return acc;
                }, []),
            };
        });
    }, [index]);
    return (React.createElement(React.Fragment, null, series.map(function (_a, idx) {
        var title = _a.title, correlations = _a.correlations, color = _a.color;
        return (React.createElement(Correlation, { key: title + "-" + idx, title: title, color: color, correlations: correlations, typography: typography, valueKey: valueKey }));
    })));
};
export default TooltipContent;
